import React, { Component } from "react";
import { connect } from "react-redux";
import { IntlProvider, addLocaleData } from "react-intl";
import localeData from "./messages.json";
import PropTypes from "prop-types";

import en from "react-intl/locale-data/en";
import pl from "react-intl/locale-data/pl";
import es from "react-intl/locale-data/es";
addLocaleData([...en, ...pl, ...es]);


export const getIntlMessage = (language, intlKey, defaultMessage) => {
  let messages = localeData[language] || localeData.en;
  const { intl } = new IntlProvider({ locale: language, messages: messages }, {}).getChildContext();
  let intlMessage = intl.formatMessage({ id: intlKey, defaultMessage: defaultMessage });
  return intlMessage;
}


class DynamicIntlProvider extends Component {

  render() {
    let language = this.props.userSettings ? this.props.userSettings.language : "en";
    let languageWithoutRegion = language.toLowerCase().split(/[_-]+/)[0];
    let messages = localeData[language] || localeData[languageWithoutRegion] || localeData.en;

    return (
      <IntlProvider locale={language} key={language} messages={messages}>
        {this.props.children}
      </IntlProvider>
    );
  }
}


function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
}

export default connect(mapStateToProps)(DynamicIntlProvider);

DynamicIntlProvider.propTypes = {
  userSettings: PropTypes.shape({
    language: PropTypes.string,
  }),
  children: PropTypes.node,
};
